import { useEffect, useSyncExternalStore } from 'react'
import { STANDZEIT_MS, abonniereErfolg, erfolg, schliesseErfolg } from './Erfolgsstelle'
import { t } from './sprache'

/**
 * **Was gelang, sagt ein Kästchen oben rechts** (7.2 Abschnitt 34, R1130) —
 * einmal eingehängt um die ganze Anwendung, wie das Störungsfenster.
 *
 * Es verdeckt nichts, was man braucht, und **fängt keinen Klick ab, der nicht
 * ihm gilt**: Ohne Aufforderung lässt es jeden Klick durch, und wer scrollt,
 * scrollt wie ohne Kästchen. Nach fünf Sekunden ist es von selbst weg.
 *
 * **Hängt eine Aufforderung daran, bleibt es** (R1132), bis es geschlossen
 * wird — der Satz mit seinem Knopf zum Weg darf nicht verschwinden, bevor er
 * gelesen ist.
 */
export function Erfolgskaestchen() {
  const e = useSyncExternalStore(abonniereErfolg, erfolg)
  const bleibt = (e?.aufforderungen.length ?? 0) > 0

  useEffect(() => {
    if (!e || bleibt) {
      return
    }
    const weg = window.setTimeout(schliesseErfolg, STANDZEIT_MS)
    return () => window.clearTimeout(weg)
  }, [e, bleibt])

  if (!e) {
    return null
  }

  return (
    <div className={bleibt ? 'erfolgskaestchen bleibt' : 'erfolgskaestchen'} role="status" aria-live="polite">
      <p className="erfolgssatz">{e.satz}</p>

      {e.aufforderungen.map((a, i) => (
        <div key={i} className="aufforderung">
          <p>{a.satz}</p>
          <button
            type="button"
            onClick={() => {
              schliesseErfolg()
              a.aufKnopf()
            }}
          >
            {a.knopf}
          </button>
        </div>
      ))}

      {bleibt && (
        <button type="button" className="schliessen" aria-label={t('fenster.schliessen')} onClick={schliesseErfolg}>
          ×
        </button>
      )}
    </div>
  )
}
